export default __webpack_public_path__ + "static/media/modoAdm.7611c92c.png";